



















import Vue from "vue"
import color from "~/config/color"

export default Vue.extend({
  props: {
    // v-modelとして渡すと、valueとして値が格納される。
    value: {
      type: Boolean,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  computed: {
    keyColor() {
      return color.keyColor
    },
  },
  methods: {
    updateValue(value: boolean): void {
      // 呼び出し元の v-model で newVal の値を受け取り、 value が更新される。
      this.$emit("input", value)
    },
  },
})
